/**
 * 绝对价带：只挡「错源级」离谱值（如白银写成伦敦银 58 USD、或量纲错配）。
 *
 * 与后端 `kline-aggregator.ts` 的 `ABSOLUTE_PRICE_BANDS` 逐条对齐——前端只做最后一道
 * 粗过滤；「12.x vs 13.x」这类细粒度脏价由后端 `kline-live-merge.ts` 的相对带兜底：
 *   - `isKlinePriceOutOfBand(price, refClose, hardSkipPct)` 相对上一收盘的硬偏离
 *   - `clampToBand(price, ref, maxDevPct)` 软夹逼到参照价 ±LIVE_KLINE_ALIGN_MAX_DEV_PCT%
 * 因此前端不再用「实时更严绝对下限」二次卡（曾用 physical_silver.min=13，会误杀银价正常回调）。
 */
export const QUOTE_ABSOLUTE_BANDS: Record<string, { min: number; max: number }> = {
  physical_silver: { min: 5, max: 30 },
  physical_gold: { min: 200, max: 2000 },
  physical_platinum: { min: 100, max: 1200 },
  physical_palladium: { min: 50, max: 3000 },
  physical_rhodium: { min: 50, max: 20_000 },
  au999: { min: 200, max: 2000 },
  au_td: { min: 200, max: 2000 },
  mau_td: { min: 200, max: 2000 },
  ag_td: { min: 5_000, max: 50_000 },
  pt9995: { min: 100, max: 1200 },
  xau_spot: { min: 1_000, max: 8_000 },
  xag_spot: { min: 10, max: 150 },
  xpt_spot: { min: 200, max: 4_000 },
  xpd_spot: { min: 200, max: 5_000 },
}

export function isQuotePriceOutOfAbsoluteBand(symbol: string, price: number): boolean {
  const band = QUOTE_ABSOLUTE_BANDS[symbol]
  if (!band || !(price > 0)) return false
  return price < band.min || price > band.max
}

/**
 * 实时展示脏价判定（首页 / WS / 列表逐维守卫）。
 * 现与日K 用同一套绝对带；细粒度相对偏离由后端聚合兜底（见文件头）。
 */
export function isQuoteLivePriceOutOfBand(symbol: string, price: number): boolean {
  return isQuotePriceOutOfAbsoluteBand(symbol, price)
}
